// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__fST1z","title":"error_title__56E4x","img":"error_img__b3YM+","text":"error_text__gtLnn"};